import React from "react"
import ToastNotification from "./ToastNotification"

export interface ToastFailProps {
  message: string
}

const ToastFail: React.FC<ToastFailProps> = ({ message }) => (
  <ToastNotification message={message} type="fail" />
)

export default ToastFail
